<script setup lang="ts">
    import { computed } from 'vue';
    import { InputRow, MultiCombobox } from '@/components/ui/form';
    import { useCreditCardData } from '@/composables/useCreditCardData';
    import { useI18n } from 'vue-i18n';
    import { usePage, router } from '@inertiajs/vue3';
    import type { SharedData } from '@/types';
    // import { Button } from '@/components/ui/button';
    // import { Plus } from 'lucide-vue-next';

    const page = usePage<SharedData>();
    const selectedCompanyId = computed(() => page.props.auth.user.selected_company_id);

    const { t } = useI18n();

    const { creditCards } = useCreditCardData(selectedCompanyId.value);

    defineProps<{
        form: any;
    }>();
</script>

<template>
    <div class="grid gap-3">
        <InputRow
            :form="form"
            name="credit_cards"
            label="employee.credit_cards.assigned"
        >
            <MultiCombobox
                id="credit_cards"
                v-model="form.credit_cards"
                :options="creditCards"
                label-by="name"
                value-by="id"
                :placeholder="t('employee.credit_cards.assigned')"
            />
            <!-- <template #label>
                <Button
                    variant="ghost"
                    size="none"
                    class="ml-auto text-xs"
                    tabindex="-1"
                    @click.prevent="router.visit(route('v2.credit-cards.index'))"
                >
                    {{ t('employee.credit_cards.credit_card') }}
                    <Plus class="text-accent size-3" />
                </Button>
            </template> -->
        </InputRow>
    </div>
</template>
